<template>
  <!-- ----------------- -->
  <!-- TOP ROW (HEADER)  -->
  <!-- ----------------- -->
  <div class="mt-3">
    <div class="mt-3">
      <div class="row">
        <p class="bb-sheet-title">TALLIES</p>
      </div>
    </div>
  </div>
</template>
    
<script>
// import store from "../store/index";
// import { mapGetters, mapMutations } from "vuex";

export default {
  name: 'CharacterSheetTallies',
  //========================================
  // component
  //-----------
  components: {},
  //========================================
  // props
  //-------
  props: {
    // arena: {
    //   type: Object,
    //   required: true,
    // },
  },
  //========================================
  // data
  //------
  data() {
    return {
      // lockArenaImg: import("/assets/images/bbLockArena.png"),
    }
  },
  //========================================
  // computed
  //----------
  computed: {
    // ...mapGetters("auth", {
    //   getUserProfile: "getUserProfile",
    // }),
    // arena_id() {
    //   return this.arena.id;
    // },
  },
  //========================================
  // methods
  //---------
  methods: {
    // ...mapMutations("combat", {
    //   setArena: "setArena",
    // }),
    // manageCombat() {
    //   // store selected arena
    //   store.commit("combat/setArena", this.arena);
    //   // route to arena
    //   router.push({ name: "manageCombat", params: { slug: this.arena.slug } });
    // },
  },
}
</script>

<!-- <style scoped>

</style> -->